module.exports = __webpack_public_path__ + "fonts/Graphik-BoldItalic.49fe9889.woff";